import { Injectable, Type } from '@angular/core';
import { BehaviorSubject, Observable, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class OverlaySideFormService {
  private _isPanelVisible: boolean;
  private _closePanelSource: BehaviorSubject<boolean>;
  _hrefComponent:any
  private _closePanel: Subject<boolean>;
  private _contentChangeSource: Subject<Type<any>>;
  private _contentChangeTitle: Subject<any>;
  private _contentChangeHelp: Subject<any>;
  private _changeTitle:Subject<Type<any>>;
  private _widthChange:Subject<any>;
  private _heightChange:Subject<any>;
  private _index
 

 // @Output() changedUser = new EventEmitter(); // emitter per cambio utente
  constructor() {
    this._isPanelVisible = false;
    this._closePanelSource = new BehaviorSubject<boolean>(this._isPanelVisible);
    this._contentChangeSource = new Subject<any>();
    this._closePanel = new Subject<boolean>();
    this._contentChangeTitle = new Subject<any>();
    this._contentChangeHelp = new Subject<any>();
    this._widthChange= new Subject<any>();
    this._heightChange= new Subject<any>();
  }
  
  private _dataToComponent = new BehaviorSubject<any>('');
  dataToComponent = this._dataToComponent.asObservable();
 
  private _sendClass = new BehaviorSubject<any>('');
  sendClass = this._sendClass.asObservable();

  private _toolbarComponent = new BehaviorSubject<any>('');
  toolbarComponent = this._toolbarComponent.asObservable();

  public onPanelClose(): Observable<boolean> {
    return this._closePanel.asObservable();
  }
  public onPanelVibilityChange(): Observable<boolean> {
    return this._closePanelSource.asObservable();
  }
  public contentChangeTitle():  Observable<any>  {
    return this._contentChangeTitle.asObservable();
  }
  public contentChangeHelp(): Observable<any> {
    return this._contentChangeHelp.asObservable();
  }
 

  public onContentChange(): Observable<Type<any>> {
    return this._contentChangeSource.asObservable();
  }
  public setTitle(content: string): void {   
    this._contentChangeTitle.next(content);
  }
  public setContent(content: Type<any>): void {   
    this._contentChangeSource.next(content);
  }
  public setHelp(help: string): void {   
    this._contentChangeHelp.next(help);
  }

  

  public onPopupWidthChanged():Observable<any>{
    return this._widthChange.asObservable();
  }

  public setPopupWidth(content:any):void{
    this._widthChange.next(content);
  }

  public onPopupHeightChanged():Observable<any>{
    return this._heightChange.asObservable();
  }

  public setPopupHeight(content:any):void{
    this._heightChange.next(content);
  }

  public show(): void {
    
    this._isPanelVisible = true;
    this._closePanelSource.next(this._isPanelVisible);
  }
  public close(): void {  
    
    this._isPanelVisible = false;
    this.onPanelVibilityChange();
    this._closePanelSource.next(this._isPanelVisible);
    this._toolbarComponent.next(false)
    this._dataToComponent.next([])
    this._closePanel.next(true);
    
  }

  public sendDataToComponent(data){   
    this._dataToComponent.next(data)
  }
  public sendClassToComponent(data){
   
    this._sendClass.next(data)
  }

  public setToolBarVisible(dataBoolean){
    this._toolbarComponent.next(dataBoolean)
  }
}
